import { createListenerMiddleware } from '@reduxjs/toolkit';
import { Filters, sortingHelper } from '@ui/src';
import { CustomersRootState } from '../../../../store/state';
import {
  CardsTransactions,
  CardTransaction,
  TariffsLog,
  TariffLogTypeEnum,
} from '../../types';
import { cardsTransactionFiltersHelper } from './fitlers-helper';
import {
  getCardsTransactions,
  getCardsTransactionsSuccess,
  onFilterCardsTransactionsList,
  onFilterListCardsTransactionsSuccess,
  onSortCardsTransactionsList,
  onSortCardsTransactionsListSuccess,
  getCardTransaction,
  getCardTransactionSuccess,
} from '../slices/accounts-statements';
import {
  getCardsTransactions as getCardsPageTransactions,
  getCardsTransactionsSuccess as getCardsPageTransactionsSuccess,
  onFilterCardsTransactionsList as onFilterCardsPageTransactionsList,
  onFilterListCardsTransactionsSuccess as onFilterCardsPageTransactionsListSuccess,
  onSortCardsTransactionsList as onSortCardsPageTransactionsList,
  onSortCardsTransactionsListSuccess as onSortCardsPageTransactionsListSuccess,
} from '../slices/cards';
import {
  getCardsTransactions as getCardsStatementsTransactions,
  getCardsTransactionsSuccess as getCardsStatementsTransactionsSuccess,
  onFilterCardsTransactionsList as onFilterCardsStatementsTransactionsList,
  onFilterListCardsTransactionsSuccess as onFilterCardsStatementsTransactionsListSuccess,
  onSortCardsTransactionsList as onSortCardsStatementsTransactionsList,
  onSortCardsTransactionsListSuccess as onSortCardsStatementsTransactionsListSuccess,
} from '../slices/statements';
import { getLogs, getLogsSuccess } from '../slices/tariffs/tariff';

const customerAccountsCardsTransactionsMock: CardsTransactions[] = [
  {
    id: 'uuid-1',
    date: new Date().toISOString(),
    description: 'Chargeback',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-2',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '38.00',
    merchantName: 'Five guys',
    orderDetails: '448-89808',
  },
  {
    id: 'uuid-3',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '117.50',
    merchantName: 'Five guys',
    orderDetails: '55874108/898',
  },
  {
    id: 'uuid-4',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'canceled',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Order 78881-1',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-5',
    date: new Date().toISOString(),
    description: 'Debit',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Five guys',
    orderDetails: 'Order35532',
  },
  {
    id: 'uuid-6',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'warning',
    currency: 'EUR',
    amount: '-345.00',
    merchantName: 'Five guys',
    orderDetails: '16778900-34',
  },
  {
    id: 'uuid-7',
    date: new Date().toISOString(),
    description: 'Refund',
    currency: 'EUR',
    amount: '-38.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-8',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-9',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-10',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-11',
    date: new Date().toISOString(),
    description: 'Chargeback',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-12',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '38.00',
    merchantName: 'Five guys',
    orderDetails: '448-89808',
  },
  {
    id: 'uuid-13',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '117.50',
    merchantName: 'Five guys',
    orderDetails: '55874108/898',
  },
  {
    id: 'uuid-14',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'canceled',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Order 78881-1',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-15',
    date: new Date().toISOString(),
    description: 'Debit',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Five guys',
    orderDetails: 'Order35532',
  },
  {
    id: 'uuid-16',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'warning',
    currency: 'EUR',
    amount: '-345.00',
    merchantName: 'Five guys',
    orderDetails: '16778900-34',
  },
  {
    id: 'uuid-17',
    date: new Date().toISOString(),
    description: 'Refund',
    currency: 'EUR',
    amount: '-38.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-18',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-19',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-20',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
];

const customerAmlCardsTransactionsMock: CardsTransactions[] = [
  {
    id: 'uuid-1',
    date: new Date().toISOString(),
    description: 'Chargeback',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-2',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'canceled',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Order 78881-1',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-3',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'warning',
    currency: 'EUR',
    amount: '-345.00',
    merchantName: 'Five guys',
    orderDetails: '16778900-34',
  },
];

const cardTransactionMock: CardTransaction = {
  id: 'uuid-1',
  description: 'Debit',
  currency: 'gbp',
  amountBc: '117.50',
  amount: '101.27',
  merchantName: 'M&S Foods',
  terminalId: 'Amazon FR',
  date: new Date().toISOString(),
};

const customerCardsTransactionsMock: CardsTransactions[] = [
  {
    id: 'uuid-1',
    date: new Date().toISOString(),
    description: 'Chargeback',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-2',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '38.00',
    merchantName: 'Five guys',
    orderDetails: '448-89808',
  },
  {
    id: 'uuid-3',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '117.50',
    merchantName: 'Five guys',
    orderDetails: '55874108/898',
  },
  {
    id: 'uuid-4',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'canceled',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Order 78881-1',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-5',
    date: new Date().toISOString(),
    description: 'Debit',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Five guys',
    orderDetails: 'Order35532',
  },
  {
    id: 'uuid-6',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'warning',
    currency: 'EUR',
    amount: '-345.00',
    merchantName: 'Five guys',
    orderDetails: '16778900-34',
  },
  {
    id: 'uuid-7',
    date: new Date().toISOString(),
    description: 'Refund',
    currency: 'EUR',
    amount: '-38.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-8',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-9',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-10',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
];

const logsMock: TariffsLog[] = [
  {
    id: 'uuid-1',
    type: TariffLogTypeEnum.CHANGED_WRITE_OFF_TYPE,
    tariff: {
      id: 't-uuid-1',
      name: 'Classic Low Individual Default',
    },
    fee: {
      id: 'f-uuid-1',
      name: 'in Transaction Fee: SEPA',
    },
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    from: 'Fixed value',
    to: 'Percent of balance',
    date: new Date().toISOString(),
  },
  {
    id: 'uuid-2',
    type: TariffLogTypeEnum.SET_WRITE_OFF_VALUE,
    tariff: {
      id: 't-uuid-1',
      name: 'Classic Low Individual Default',
    },
    fee: {
      id: 'f-uuid-1',
      name: 'in Transaction Fee: SEPA',
    },
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    value: '1.5%',
    date: new Date().toISOString(),
  },
  {
    id: 'uuid-3',
    type: TariffLogTypeEnum.CHANGED_WRITE_OFF_VALUE,
    tariff: {
      id: 't-uuid-1',
      name: 'Classic Low Individual Default',
    },
    fee: {
      id: 'f-uuid-1',
      name: 'in Transaction Fee: SEPA',
    },
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    from: '3%',
    to: '1.5%',
    date: new Date().toISOString(),
  },
  {
    id: 'uuid-4',
    type: TariffLogTypeEnum.CHANGED_WRITE_OFF_VALUE,
    tariff: {
      id: 't-uuid-1',
      name: 'Classic Low Individual Default',
    },
    fee: {
      id: 'f-uuid-1',
      name: 'in Regular Fee: High-Balance',
    },
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    from: '2%',
    to: '1.5%',
    date: new Date().toISOString(),
  },
  {
    id: 'uuid-5',
    type: TariffLogTypeEnum.SET_WRITE_OFF_VALUE,
    tariff: {
      id: 't-uuid-1',
      name: 'Premium black',
    },
    fee: {
      id: 'f-uuid-1',
      name: 'in Regular Fee: High-Balance 1D',
    },
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    value: '1.5%',
    date: new Date().toISOString(),
  },
  {
    id: 'uuid-6',
    type: TariffLogTypeEnum.CHANGED_TARIFF,
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    from: 'Premium black',
    to: 'Classic Low Individual Default',
    date: new Date().toISOString(),
  },
  {
    id: 'uuid-7',
    type: TariffLogTypeEnum.CHANGED_WRITE_OFF_VALUE,
    tariff: {
      id: 't-uuid-1',
      name: 'Premium black',
    },
    fee: {
      id: 'f-uuid-1',
      name: 'in Regular Fee: High-Balance 1D',
    },
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    from: '2%',
    to: '1.5%',
    date: new Date().toISOString(),
  },
  {
    id: 'uuid-8',
    type: TariffLogTypeEnum.SET_WRITE_OFF_VALUE,
    tariff: {
      id: 't-uuid-1',
      name: 'Premium black',
    },
    fee: {
      id: 'f-uuid-1',
      name: 'in Regular Fee: High-Balance 1D',
    },
    user: {
      firstName: 'Christian',
      lastName: 'Evans',
    },
    value: '1.5%',
    date: new Date().toISOString(),
  },
];

const customerMiddleware = createListenerMiddleware();

customerMiddleware.startListening({
  actionCreator: getCardsTransactions,
  effect: async (action, listenerApi) => {
    let nextList: CardsTransactions[] = customerAccountsCardsTransactionsMock;

    if (action.payload.page === 'aml') {
      nextList = customerAmlCardsTransactionsMock;
    }

    if (action.payload) {
      if (
        action.payload.name &&
        action.payload.direction &&
        !action.payload.filters
      ) {
        nextList = sortingHelper<CardsTransactions>(
          nextList,
          action.payload.name,
          action.payload.direction,
        );
      }

      if (action.payload.filters) {
        const nextFilters: Filters = {};

        Object.keys(action.payload.filters).forEach((key) => {
          if (
            (action?.payload?.filters as Filters)[key] &&
            (action.payload.filters as Filters)[key].value.length < 2
          ) {
            nextFilters[key] = {
              ...nextFilters[key],
              value: [(action.payload.filters as Filters)[key].value.join()],
            };
          } else {
            nextFilters[key] = (action?.payload?.filters as Filters)[key];
          }
        });

        nextList = cardsTransactionFiltersHelper(
          nextList,
          action.payload?.name as string,
          action.payload?.direction as 'asc' | 'desc',
          nextFilters,
        );
      }
    }

    setTimeout(() => {
      listenerApi.dispatch(getCardsTransactionsSuccess(nextList));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: onSortCardsTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerAccountsStatements: {
        cardsTransactions: { values },
      },
    } = listenerApi.getState() as CustomersRootState;

    if (values) {
      const nextTransactions = sortingHelper<CardsTransactions>(
        [...values],
        action.payload.name,
        action.payload.direction,
      );

      setTimeout(() => {
        listenerApi.dispatch(
          onSortCardsTransactionsListSuccess(nextTransactions),
        );
        listenerApi.cancelActiveListeners();
      }, 1000);
    }
  },
});

customerMiddleware.startListening({
  actionCreator: onFilterCardsTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerAccountsStatements: {
        page,
        cardsTransactions: { sort },
      },
    } = listenerApi.getState() as CustomersRootState;

    const nextFilters: Filters = {};

    Object.keys(action.payload).forEach((key) => {
      if (action.payload[key] && action.payload[key].value.length < 2) {
        nextFilters[key] = {
          ...nextFilters[key],
          value: [action.payload[key].value.join()],
        };
      } else {
        nextFilters[key] = action.payload[key];
      }
    });

    let list = customerAccountsCardsTransactionsMock;

    if (page === 'aml') {
      list = customerAmlCardsTransactionsMock;
    }

    const nextTrancastions = cardsTransactionFiltersHelper(
      list,
      sort?.sortProp as string,
      sort?.sortDir as 'asc' | 'desc',
      nextFilters,
    );

    setTimeout(() => {
      listenerApi.dispatch(
        onFilterListCardsTransactionsSuccess(nextTrancastions),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: getCardTransaction,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(getCardTransactionSuccess(cardTransactionMock));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: getCardsPageTransactions,
  effect: async (action, listenerApi) => {
    let nextList: CardsTransactions[] = customerCardsTransactionsMock;

    if (action.payload) {
      if (
        action.payload.name &&
        action.payload.direction &&
        !action.payload.filters
      ) {
        nextList = sortingHelper<CardsTransactions>(
          customerCardsTransactionsMock,
          action.payload.name,
          action.payload.direction,
        );
      }

      if (action.payload.filters) {
        const nextFilters: Filters = {};

        Object.keys(action.payload.filters).forEach((key) => {
          if (
            (action?.payload?.filters as Filters)[key] &&
            (action.payload.filters as Filters)[key].value.length < 2
          ) {
            nextFilters[key] = {
              ...nextFilters[key],
              value: [(action.payload.filters as Filters)[key].value.join()],
            };
          } else {
            nextFilters[key] = (action?.payload?.filters as Filters)[key];
          }
        });

        nextList = cardsTransactionFiltersHelper(
          customerCardsTransactionsMock,
          action.payload?.name as string,
          action.payload?.direction as 'asc' | 'desc',
          nextFilters,
        );
      }
    }

    setTimeout(() => {
      listenerApi.dispatch(getCardsPageTransactionsSuccess(nextList));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: onSortCardsPageTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerCards: { values },
    } = listenerApi.getState() as CustomersRootState;

    if (values) {
      const nextTransactions = sortingHelper<CardsTransactions>(
        [...values],
        action.payload.name,
        action.payload.direction,
      );

      setTimeout(() => {
        listenerApi.dispatch(
          onSortCardsPageTransactionsListSuccess(nextTransactions),
        );
        listenerApi.cancelActiveListeners();
      }, 1000);
    }
  },
});

customerMiddleware.startListening({
  actionCreator: onFilterCardsPageTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerCards: { sort },
    } = listenerApi.getState() as CustomersRootState;

    const nextFilters: Filters = {};

    Object.keys(action.payload).forEach((key) => {
      if (action.payload[key] && action.payload[key].value.length < 2) {
        nextFilters[key] = {
          ...nextFilters[key],
          value: [action.payload[key].value.join()],
        };
      } else {
        nextFilters[key] = action.payload[key];
      }
    });

    const nextTrancastions = cardsTransactionFiltersHelper(
      customerCardsTransactionsMock,
      sort?.sortProp as string,
      sort?.sortDir as 'asc' | 'desc',
      nextFilters,
    );

    setTimeout(() => {
      listenerApi.dispatch(
        onFilterCardsPageTransactionsListSuccess(nextTrancastions),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: getCardsStatementsTransactions,
  effect: async (action, listenerApi) => {
    let nextList: CardsTransactions[] = customerCardsTransactionsMock;

    if (action.payload) {
      if (
        action.payload.name &&
        action.payload.direction &&
        !action.payload.filters
      ) {
        nextList = sortingHelper<CardsTransactions>(
          customerCardsTransactionsMock,
          action.payload.name,
          action.payload.direction,
        );
      }

      if (action.payload.filters) {
        const nextFilters: Filters = {};

        Object.keys(action.payload.filters).forEach((key) => {
          if (
            (action?.payload?.filters as Filters)[key] &&
            (action.payload.filters as Filters)[key].value.length < 2
          ) {
            nextFilters[key] = {
              ...nextFilters[key],
              value: [(action.payload.filters as Filters)[key].value.join()],
            };
          } else {
            nextFilters[key] = (action?.payload?.filters as Filters)[key];
          }
        });

        nextList = cardsTransactionFiltersHelper(
          customerCardsTransactionsMock,
          action.payload?.name as string,
          action.payload?.direction as 'asc' | 'desc',
          nextFilters,
        );
      }
    }

    setTimeout(() => {
      listenerApi.dispatch(getCardsStatementsTransactionsSuccess(nextList));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: onSortCardsStatementsTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerStatements: {
        cardsTransactions: { values },
      },
    } = listenerApi.getState() as CustomersRootState;

    if (values) {
      const nextTransactions = sortingHelper<CardsTransactions>(
        [...values],
        action.payload.name,
        action.payload.direction,
      );

      setTimeout(() => {
        listenerApi.dispatch(
          onSortCardsStatementsTransactionsListSuccess(nextTransactions),
        );
        listenerApi.cancelActiveListeners();
      }, 1000);
    }
  },
});

customerMiddleware.startListening({
  actionCreator: onFilterCardsStatementsTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerStatements: {
        cardsTransactions: { sort },
      },
    } = listenerApi.getState() as CustomersRootState;

    const nextFilters: Filters = {};

    Object.keys(action.payload).forEach((key) => {
      if (action.payload[key] && action.payload[key].value.length < 2) {
        nextFilters[key] = {
          ...nextFilters[key],
          value: [action.payload[key].value.join()],
        };
      } else {
        nextFilters[key] = action.payload[key];
      }
    });

    const nextTrancastions = cardsTransactionFiltersHelper(
      customerCardsTransactionsMock,
      sort?.sortProp as string,
      sort?.sortDir as 'asc' | 'desc',
      nextFilters,
    );

    setTimeout(() => {
      listenerApi.dispatch(
        onFilterCardsStatementsTransactionsListSuccess(nextTrancastions),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: getLogs,
  effect: async (action, listenerApi) => {
    setTimeout(() => {
      listenerApi.dispatch(getLogsSuccess(logsMock));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

export default customerMiddleware;
